import type { ComplianceDoc } from '@/types';

export const fmtSize = (b: number) =>
  b > 1024 * 1024 ? (b / (1024 * 1024)).toFixed(1) + ' MB' : Math.ceil(b / 1024) + ' KB';

const pad2 = (n: number) => String(n).padStart(2, '0');

/** dd-mm-yyyy */
export function fmtD(s: string | null | undefined): string {
  if (!s) return '';
  const parts = String(s).slice(0, 10).split('-');
  return parts[2] + '-' + parts[1] + '-' + parts[0];
}

/** dd-mm-yyyy · hh:mm for full timestamps, dd-mm-yyyy for date-only values */
export function fmtDT(iso: string | null | undefined): string {
  if (!iso) return '';
  if (String(iso).length <= 10) return fmtD(iso);
  const t = new Date(iso);
  return `${pad2(t.getDate())}-${pad2(t.getMonth() + 1)}-${t.getFullYear()} · ${pad2(t.getHours())}:${pad2(t.getMinutes())}`;
}

/** Verification traffic light: red <33 · yellow 33–99 · green 100. */
export const pctColor = (pct: number) =>
  pct >= 100 ? 'var(--ok)' : pct >= 33 ? 'var(--warn)' : 'var(--err)';

/** El archivo puede no estar en memoria: contra la API se trae del
 *  servidor al abrirlo o al descargarlo, así que la URL llega de fuera. */
export function triggerDownload(doc: ComplianceDoc, url: string) {
  const a = document.createElement('a');
  a.href = url;
  a.download = doc.name;
  document.body.appendChild(a);
  a.click();
  a.remove();
}
